import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from 'axios';

export interface RouteParams {
  [key: string]: string | number | undefined;
}

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  routeParams?: RouteParams;
}

interface CustomInternalAxiosRequestConfig extends InternalAxiosRequestConfig {
  routeParams?: RouteParams;
}

const IS_DEV = import.meta.env.VITE_IS_DEV;

class HttpClient {
  readonly instance: AxiosInstance;

  constructor(baseURL: string) {
    this.instance = axios.create({
      baseURL,
      headers: {
        'ngrok-skip-browser-warning': IS_DEV === 'true' ? true : false,
      },
    });
    this.setupInterceptors();
  }

  private setupInterceptors() {
    this.instance.interceptors.request.use(
      (config: CustomInternalAxiosRequestConfig) => {
        if (config.routeParams) {
          config.url = this.interpolateRouteParams(
            config.url || '',
            config.routeParams,
          );
        }
        return config;
      },
      (error) => Promise.reject(error),
    );
  }

  private interpolateRouteParams(
    url: string,
    params: Record<string, string | number | undefined>,
  ): string {
    return url.replace(/:(\w+)/g, (_, key) => {
      return params[key]?.toString() || `:${key}`;
    });
  }
  public get<T = any>(url: string, config?: CustomAxiosRequestConfig) {
    return this.instance.get<T>(url, config);
  }

  public post<T = any>(
    url: string,
    data?: any,
    config?: CustomAxiosRequestConfig,
  ) {
    return this.instance.post<T>(url, data, config);
  }
}

export const BASE_URL_V3 = import.meta.env.VITE_APPLICATION_HOST_API_URL_V3;
export const httpClient = new HttpClient(BASE_URL_V3);
